import { Link } from "react-router-dom";
import PageTitle from "../Helpers/PageTitle";
import Layout from "../Partials/Layout";

export default function About() {
  return (
    <Layout childrenClasses="pt-0 pb-0">
      <div className="about-page-wrapper w-full">
        <div className="title-area w-full">
          <PageTitle
            title="About Us"
            breadcrumb={[
              { name: "home", path: "/" },
              { name: "About us", path: "/about" },
            ]}
          />
        </div>

        <div className="aboutus-wrapper w-full">
          <div className="container-x mx-auto">
            <div className="w-full min-h-[665px] lg:flex lg:space-x-12 items-center pb-10 lg:pb-0">
              <div className="md:w-[570px] w-full md:h-[560px] h-auto rounded overflow-hidden my-5 lg:my-0">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/about/about-1.jpeg`}
                  alt="about"
                  className="w-full h"
                />
              </div>
              <div className="content flex-1">
                {/* <h1 className="text-[18px] font-medium text-qblack mb-2.5">
                  What is e-commerce business?
                </h1> */}
                <p className="text-[15px] text-qgraytwo leading-7 mb-2.5">
                  Welcome to Hashtag, your ultimate destination for effortless e-commerce product sourcing and dropshipping. We take pride in providing a seamless platform that connects online retailers with suppliers, streamlining the entire process for a successful e-commerce venture. Our mission is to empower businesses, big and small, by offering a wide range of features and tools that enhance productivity and profitability.
                </p>
                {/* <ul className="text-[15px] text-qgraytwo leading-7 list-disc ml-5 mb-5">
                  <li>slim body with metal cover</li>
                  <li>
                    latest Intel Core i5-1135G7 processor (4 cores / 8 threads)
                  </li>
                  <li>8GB DDR4 RAM and fast 512GB PCIe SSD</li>
                  <li>
                    NVIDIA GeForce MX350 2GB GDDR5 graphics card backlit
                    keyboard
                  </li>
                </ul> */}

                {/* <Link to="/contact">
                  <div className="w-[121px] h-10">
                    <span className="yellow-btn">Contact Us</span>
                  </div>
                </Link> */}
              </div>
            </div>
          </div>
          <div className="container-x mx-auto">
            <div className="w-full min-h-[665px] lg:flex lg:space-x-12 items-center pb-10 lg:pb-0">
              <div className="content flex-1">
                <h1 className="text-[18px] font-medium text-qblack mb-2.5">
                  Our Vision
                </h1>
                <p className="text-[15px] text-qgraytwo leading-7 mb-2.5">
                  At Hashtag, we envision a world where e-commerce entrepreneurs can focus on growth and customer satisfaction, while we take care of the product sourcing and logistics. Our platform aims to simplify the dropshipping process, making it accessible and rewarding for every business, regardless of their scale.
                </p>
              </div>
              <div className="md:w-[570px] w-full md:h-[560px] h-auto rounded overflow-hidden my-5 lg:my-0">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/about/about-3.jpeg`}
                  alt="about"
                  className="w-full h"
                />
              </div>
            </div>
          </div>
          <div className="container-x mx-auto">
            <div className="w-full min-h-[665px] lg:flex lg:space-x-12 items-center pb-10 lg:pb-0">
              <div className="md:w-[570px] w-full md:h-[560px] h-auto rounded overflow-hidden my-5 lg:my-0">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/about/about-2.jpeg`}
                  alt="about"
                  className="w-full h"
                />
              </div>
              <div className="content flex-1">
                <h1 className="text-[18px] font-medium text-qblack mb-2.5">
                  Simplified Product Sourcing
                </h1>
                <p className="text-[15px] text-qgraytwo leading-7 mb-2.5">
                  Finding the right products for your online store can be a time-consuming task. With Hashtag, you can bid farewell to those challenges. Our intuitive platform allows you to discover thousands of high-quality products from trusted suppliers effortlessly. Say goodbye to inventory woes and let us handle the sourcing for you.
                </p>
              </div>
            </div>
          </div>
          <div className="container-x mx-auto">
            <div className="w-full min-h-[665px] lg:flex lg:space-x-12 items-center pb-10 lg:pb-0">
              <div className="content flex-1">
                <h1 className="text-[18px] font-medium text-qblack mb-2.5">
                  Seamless Integration
                </h1>
                <p className="text-[15px] text-qgraytwo leading-7 mb-2.5">
                  Hashtag seamlessly integrates with popular e-commerce platforms, making it a breeze for you to import products directly into your online store. Whether you use Shopify, WooCommerce, or any other platform, we have got you covered. Experience hassle-free product management and focus on what matters most - growing your business.
                </p>
              </div>
              <div className="md:w-[570px] w-full md:h-[560px] h-auto rounded overflow-hidden my-5 lg:my-0">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/about/about-6.jpeg`}
                  alt="about"
                  className="w-full h"
                />
              </div>
            </div>
          </div>
          <div className="container-x mx-auto">
            <div className="w-full min-h-[665px] lg:flex lg:space-x-12 items-center pb-10 lg:pb-0">
              <div className="md:w-[570px] w-full md:h-[560px] h-auto rounded overflow-hidden my-5 lg:my-0">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/about/about-4.jpeg`}
                  alt="about"
                  className="w-full h"
                />
              </div>
              <div className="content flex-1">
                <h1 className="text-[18px] font-medium text-qblack mb-2.5">
                  Real-Time Inventory Management
                </h1>
                <p className="text-[15px] text-qgraytwo leading-7 mb-2.5">
                  With Hashtag, you can wave goodbye to the days of overselling or dealing with out-of-stock items. Our platform provides real-time inventory updates, ensuring that you and your customers stay informed about product availability at all times. Say hello to efficient inventory management and an improved customer experience.
                </p>
              </div>
            </div>
          </div>
          <div className="container-x mx-auto">
            <div className="w-full min-h-[665px] lg:flex lg:space-x-12 items-center pb-10 lg:pb-0">
              <div className="content flex-1">
                <h1 className="text-[18px] font-medium text-qblack mb-2.5">
                  Hassle-Free Order Fulfillment
                </h1>
                <p className="text-[15px] text-qgraytwo leading-7 mb-2.5">
                  Processing orders should be the least of your worries. Hashtag's automated order fulfillment system takes care of the entire process for you. Once a customer places an order, we handle the rest - from packaging to shipping. Sit back and relax while we ensure your customers receive their purchases promptly.
                </p>
              </div>
              <div className="md:w-[570px] w-full md:h-[560px] h-auto rounded overflow-hidden my-5 lg:my-0">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/about/about-8.jpeg`}
                  alt="about"
                  className="w-full h"
                />
              </div>
            </div>
          </div>
          <div className="container-x mx-auto">
            <div className="w-full min-h-[665px] lg:flex lg:space-x-12 items-center pb-10 lg:pb-0">
              <div className="md:w-[570px] w-full md:h-[560px] h-auto rounded overflow-hidden my-5 lg:my-0">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/about/about-5.jpeg`}
                  alt="about"
                  className="w-full h"
                />
              </div>
              <div className="content flex-1">
                <h1 className="text-[18px] font-medium text-qblack mb-2.5">
                  Reliable Customer Support
                </h1>
                <p className="text-[15px] text-qgraytwo leading-7 mb-2.5">
                  At Hashtag, we prioritize the success of our users. Our dedicated customer support team is available to assist you every step of the way. From answering your queries to providing guidance on using our platform effectively, we are here for you. Count on us to provide top-notch customer support whenever you need it.                </p>
              </div>
            </div>
          </div>
          <div className="container-x mx-auto">
            <div className="w-full min-h-[665px] lg:flex lg:space-x-12 items-center pb-10 lg:pb-0">
              <div className="content flex-1">
                <h1 className="text-[18px] font-medium text-qblack mb-2.5">
                  Data-Driven Insights
                </h1>
                <p className="text-[15px] text-qgraytwo leading-7 mb-2.5">
                  Make informed decisions with our data-driven insights. Hashtag's analytics and reporting tools offer valuable information about your store's performance, customer behavior, and product trends. Utilize this knowledge to optimize your strategies and achieve sustainable growth.
                </p>
              </div>
              <div className="md:w-[570px] w-full md:h-[560px] h-auto rounded overflow-hidden my-5 lg:my-0">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/about/about-6.jpeg`}
                  alt="about"
                  className="w-full h"
                />
              </div>
            </div>
          </div>
          <div className="container-x mx-auto">
            <div className="w-full min-h-[665px] lg:flex lg:space-x-12 items-center pb-10 lg:pb-0">
              <div className="md:w-[570px] w-full md:h-[560px] h-auto rounded overflow-hidden my-5 lg:my-0">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/about/about-7.jpeg`}
                  alt="about"
                  className="w-full h"
                />
              </div>
              <div className="content flex-1">
                <h1 className="text-[18px] font-medium text-qblack mb-2.5">
                  Join Hashtag Today
                </h1>
                <p className="text-[15px] text-qgraytwo leading-7 mb-2.5">
                  Join the ever-growing community of successful e-commerce entrepreneurs who trust Hashtag for their dropshipping needs. Experience the simplicity, efficiency, and profitability that our platform offers. Take the leap into a brighter e-commerce future with Hashtag.
                </p>
                <p className="text-[15px] text-qgraytwo leading-7 mb-2.5">
                  Start your journey today and see your business reach new heights with Hashtag.
                </p>
                <Link to="/contact">
                  <div className="w-[121px] h-10">
                    <span className="yellow-btn">Contact Us</span>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>

      </div>
    </Layout>
  );
}
